import { render, staticRenderFns } from "./PictureCardList.vue?vue&type=template&id=07138d68&"
import script from "./PictureCardList.vue?vue&type=script&lang=js&"
export * from "./PictureCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports